export const VIRGIN_VELOCITY_PARTNERSHIP_CODE = 'velocity'
/** 0.007 AUD per velocity point */
export const VIRGIN_VELOCITY_BURN_RATE = 0.007
export const VIRGIN_VELOCITY_CHECKOUT_PAYMENT_METHODS = ['googlepay', 'stripe_3ds', 'applepay']
export const VIRGIN_VELOCITY_BURN_MINIMUM = 5000

export enum VIRGIN_VELOCITY_CATALOGUE_REFERENCE_MAP {
  TOUR = 'LUXTOURS',
  CRUISE = 'LUXCRUISE',
  EXPERIENCE = 'LUXEXP',
  FLIGHT = 'LUXFLTS',
  ULTRA_LUX = 'LUXULTRA',
  HOMES_VILLA = 'LUXHMVLA',
  PACKAGE = 'LUXHOLS',
  LAST_MINUTE_HOTEL = 'LUXLMESCPE',
  HOTEL = 'LUXHTLRST',
}
